import { useQueryClient } from '@tanstack/react-query';
import { useDeleteShare } from '@vindr/services/actions/share.action';
import { Share_Type } from '@vindr/services/constants/common.constant';
import { MESSAGE } from '@vindr/services/constants/message.constant';
import { queryKey } from '@vindr/services/constants/queryClientKey';
import { TableColumnsType } from 'antd';
import { MessageInstance } from 'antd/es/message/interface';
import { ModalStaticFunctions } from 'antd/es/modal/confirm';
import { useTranslation } from 'react-i18next';
import { Updater } from 'use-immer';
import handleSave from '@vindr/ui/src/components/Templates/actionSubmit';
import ColumnTemplate from '@vindr/ui/src/components/Templates/columns/columnRenderTemplates';
import ActionIcon from '@vindr/ui/src/components/ui/ActionIcon/ActionIcon';

const useDefinedSharedTableColumns = ({
  onChangeTab,
  setShareStudy,
  message,
  modal,
  setSelectedRow,
}: {
  onChangeTab: (key: any) => void;
  setShareStudy: Updater<any>;
  message: MessageInstance;
  modal: Omit<ModalStaticFunctions, 'warn'>;
  setSelectedRow: (records: any[]) => void;
}) => {
  const { t } = useTranslation('Vindoc');
  const queryClient = useQueryClient();

  const { mutate: deleteShare } = useDeleteShare();

  return [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: 40,
      render: (text, record, index) => index + 1,
    },
    {
      title: t('Share Type'),
      dataIndex: 'type',
      key: 'type',
      width: 120,
      ellipsis: true,
      render: (text) => t(Share_Type[text]),
    },
    {
      title: t('Note'),
      dataIndex: 'note',
      key: 'note',
      width: 120,
      ellipsis: true,
    },
    ColumnTemplate.Date({ type: 'created_at' }),
    ColumnTemplate.Date({ title: t('Expired At'), dataIndex: 'expired_at', key: 'expired_at' }),
    {
      title: t('Actions'),
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: 80,
      fixed: 'right',
      render: (text, record) => {
        return (
          <ActionIcon>
            <ActionIcon.Edit
              onClick={() => {
                // setOpenEditModal(record);
                onChangeTab?.('sharing');
                setShareStudy?.((draft) => {
                  draft.editItem = record;
                  draft.stateAction = 'edit';
                  draft.accessKey = record?.access_key;
                });
              }}
            />

            <ActionIcon.Delete
              onClick={() => {
                setSelectedRow([record]);
                modal.confirm({
                  className: 'delete-modal',
                  title: t(MESSAGE.DIALOG.CFD_14000),
                  okText: t('Delete'),
                  onOk: () => {
                    handleSave({
                      message,
                      deleteParams: record.id,
                      type: 'delete',
                      mutate: { delete: deleteShare },
                      code: { deleted: 'SCD_14003' },
                      t,
                      onDone: () => {
                        // onCancel();
                        queryClient.invalidateQueries([queryKey.share], { exact: false });
                      },
                    });
                  },
                });
              }}
            />
          </ActionIcon>
        );
      },
    },
  ] as TableColumnsType<any>;
};

export default useDefinedSharedTableColumns;
